import { NgOptimizedImage } from "@angular/common";
import { Component } from "@angular/core";
import { RouterLink } from "@angular/router";

@Component({
  selector: "app-job-offers",
  templateUrl: "./job-offers.component.html",
  styleUrls: ["./job-offers.component.scss"],
  imports: [RouterLink, NgOptimizedImage],
})
export class JobOffersComponent {}
